module.exports = __webpack_public_path__ + "static/media/user-icon.414e1804.jpg";